function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M0,329.712V206.368h91.456v20.864H24.912v27.344h61.92v20.784h-61.92v33.552h68.912v20.784H0 V329.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M109.552,261.056V239.36h86.24v21.696H109.552z M109.552,298.416v-21.792h86.24v21.792H109.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M213.616,240.352h21.776v12.208c7.808-9.488,17.088-14.224,27.856-14.224 c5.712,0,10.688,1.184,14.896,3.536c4.208,2.352,7.664,5.904,10.352,10.688c3.92-4.768,8.176-8.336,12.704-10.688 c4.544-2.368,9.408-3.536,14.56-3.536c6.56,0,12.128,1.344,16.656,3.984c4.544,2.672,7.952,6.576,10.192,11.744 c1.616,3.824,2.432,10,2.432,18.512v57.136h-23.648V278.64c0-8.864-0.816-14.576-2.432-17.152c-2.192-3.36-5.552-5.04-10.112-5.04 c-3.296,0-6.416,1.008-9.344,3.024c-2.912,2.016-5.008,4.976-6.304,8.88c-1.28,3.888-1.936,10.064-1.936,18.464v42.912h-23.648 v-48.96c0-8.704-0.416-14.304-1.248-16.832c-0.848-2.528-2.144-4.4-3.92-5.632c-1.76-1.232-4.16-1.84-7.184-1.84 c-3.648,0-6.912,0.976-9.84,2.928c-2.928,1.968-5.008,4.8-6.272,8.512c-1.264,3.696-1.888,9.856-1.888,18.416v43.424h-23.648 L213.616,240.352L213.616,240.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M446.528,266.784l-23.328,4.192c-0.784-4.64-2.56-8.16-5.328-10.512s-6.384-3.536-10.816-3.536 c-5.888,0-10.592,2.032-14.096,6.096c-3.504,4.064-5.248,10.864-5.248,20.4c0,10.608,1.776,18.08,5.328,22.448 c3.568,4.384,8.352,6.56,14.352,6.56c4.48,0,8.16-1.264,11.024-3.824c2.864-2.544,4.88-6.928,6.048-13.168l23.232,3.952 c-2.416,10.656-7.024,18.704-13.888,24.16c-6.832,5.424-16.016,8.16-27.504,8.16c-13.072,0-23.504-4.112-31.264-12.368 c-7.776-8.256-11.648-19.664-11.648-34.24c0-14.752,3.888-26.24,11.696-34.448c7.792-8.224,18.336-12.336,31.632-12.336 c10.88,0,19.52,2.352,25.952,7.024C439.088,250.048,443.696,257.2,446.528,266.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M512,243.952v13.728h-51.792c0.56-5.184,2.24-10.112,5.056-14.752c2.8-4.64,8.352-10.8,16.608-18.48 c6.656-6.208,10.752-10.416,12.256-12.624c2.032-3.056,3.056-6.064,3.056-9.04c0-3.296-0.896-5.824-2.656-7.6 c-1.776-1.776-4.224-2.656-7.328-2.656c-3.088,0-5.536,0.928-7.36,2.784s-2.864,4.944-3.152,9.264l-14.72-1.472 c0.864-8.128,3.616-13.968,8.256-17.504c4.624-3.552,10.416-5.312,17.36-5.312c7.616,0,13.584,2.048,17.92,6.16 c4.336,4.08,6.496,9.168,6.496,15.264c0,3.472-0.624,6.768-1.856,9.92c-1.248,3.136-3.216,6.416-5.92,9.856 c-1.776,2.288-5.008,5.552-9.68,9.84c-4.656,4.272-7.616,7.12-8.864,8.528c-1.248,1.392-2.256,2.768-3.024,4.096H512z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmc2);
export default __webpack_public_path__ + "static/media/emc2.a3e8a57d03e0ace37eddaad43db29af3.svg";
export { ForwardRef as ReactComponent };